const options = {
  5: "bg-red-700/5",
  10: "bg-red-700/10",
  25: "bg-red-700/25",
  50: "bg-red-700/50",
  75: "bg-red-700/75",
  90: "bg-red-700/90",
  100: "bg-red-700",
};

const from = {
  5: "from-red-700/5",
  10: "from-red-700/10",
  25: "from-red-700/25",
  50: "from-red-700/50",
  75: "from-red-700/75",
  90: "from-red-700/90",
  100: "from-red-700",
};

export default function getBackgroundRed700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
